<template>
    <div>
        <div class="dropdown-divider"></div>
        <li class="p-2 d-flex">
            <div class="container-fluid">
                <div class="row justify-content-start">
                    <div class="col d-flex">
                        <InfoToolTip class="mr-2" :info="info" />
                        <p class="mb-0 font-weight-bold">Marcados como spam</p>
                    </div>
                    <div v-if="etiqueta" class="col d-flex align-items-center">
                        <p class="mb-0 font-weight-bold mr-3">
                            {{ n }}
                        </p>
                        <p class="badge text-white p-1 mb-0 badge-warning">
                            {{ nEtiqueta }}
                        </p>
                    </div>
                    <div v-else class="col d-flex">
                        <p class="mb-0 font-weight-bold mr-3">
                            {{ n }}
                        </p>
                    </div>
                </div>
            </div>
        </li>
    </div>
</template>

<script>
    import InfoToolTip from '../../../../../common/InfoToolTip.vue';

    export default {
        props: ['n', 'nEtiqueta', 'etiqueta'],
        components: {
            InfoToolTip
        },
        data() {
            return {
                info: 
                    `<p>Muestra cuántos emails han sido marcados como spam por el destinatario</p>`,
            }
        }
    };
</script>
